import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ENDPOINTS } from '@shared/constants';
import { CommonResponseDTO, IInventory } from '@shared/interfaces';
import { generateURL } from '@shared/utils';

@Injectable({
  providedIn: 'root',
})
export class InventoryService {
  constructor(private http: HttpClient) {}

  public createInventory(
    inventory: IInventory
  ): Observable<CommonResponseDTO<IInventory>> {
    const url = generateURL({ endpoint: ENDPOINTS.INVENTORY_CREATE_NEW });
    return this.http.post<CommonResponseDTO<IInventory>>(url, inventory);
  }

  public assignAsset(
    inventory: IInventory,
    id: string
  ): Observable<CommonResponseDTO<IInventory>> {
    const url = generateURL({
      endpoint: ENDPOINTS.INVENTORY_UPDATE_ONE,
      params: { id },
    });
    return this.http.patch<CommonResponseDTO<IInventory>>(url, inventory);
  }

  public returnAsset(
    inventory: IInventory,
    id: string
  ): Observable<CommonResponseDTO<IInventory>> {
    const url = generateURL({
      endpoint: ENDPOINTS.INVENTORY_UPDATE_ONE,
      params: { id },
    });
    return this.http.patch<CommonResponseDTO<IInventory>>(url, inventory);
  }

  public getAllInventory(
    params: HttpParams
  ): Observable<CommonResponseDTO<IInventory[]>> {
    const url = generateURL({ endpoint: ENDPOINTS.INVENTORY_GET_ALL });
    const config = { params };
    return this.http.get<CommonResponseDTO<IInventory[]>>(url, config);
  }

  getInventoryById(id: string): Observable<CommonResponseDTO<IInventory>> {
    const url = generateURL({
      endpoint: ENDPOINTS.INVENTORY_GET_ONE,
      params: { id },
    });
    return this.http.get<CommonResponseDTO<IInventory>>(url);
  }

  public updateInventoryById(
    inventory: IInventory,
    id: string
  ): Observable<CommonResponseDTO<IInventory>> {
    const url = generateURL({
      endpoint: ENDPOINTS.INVENTORY_UPDATE_ONE,
      params: { id },
    });
    return this.http.patch<CommonResponseDTO<IInventory>>(url, inventory);
  }

  deleteInventoryById(id: string): Observable<CommonResponseDTO<IInventory>> {
    const url = generateURL({
      endpoint: ENDPOINTS.INVENTORY_DELETE_ONE,
      params: { id },
    });
    return this.http.patch<CommonResponseDTO<IInventory>>(url, {});
  }

  restoreInventoryById(id: string): Observable<CommonResponseDTO<IInventory>> {
    const url = generateURL({
      endpoint: ENDPOINTS.INVENTORY_RESTORE_ONE,
      params: { id },
    });
    return this.http.patch<CommonResponseDTO<IInventory>>(url, {});
  }
}
